import React from 'react';
import { Star } from 'lucide-react';
import { cop } from './tiendaUtils';

const Fila = ({ label, valor, fuerte, testId }) => (
  <div className={`flex items-center justify-between ${fuerte ? 'border-t border-zinc-800 pt-3 text-base font-semibold text-white' : 'text-sm text-zinc-400'}`}>
    <span>{label}</span><span className={fuerte ? 'text-[#C9A962]' : ''} data-testid={testId}>{valor}</span>
  </div>
);

export default function PasoPuntos({ info, precio, puntos, setPuntos }) {
  const max = info.max_utilizables;
  const fijar = (n) => setPuntos(Math.max(0, Math.min(max, Number.isFinite(n) ? Math.floor(n) : 0)));
  const descuento = puntos * info.valor_por_punto;

  return (
    <div className="space-y-4" data-testid="paso-puntos">
      <div className="rounded-2xl border border-[#C9A962]/25 bg-gradient-to-br from-[#C9A962]/15 to-transparent p-5">
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#C9A962]/20"><Star className="h-5 w-5 text-[#C9A962]" /></span>
          <div>
            <p className="text-xs uppercase tracking-wider text-[#C9A962]">Tus Puntos JPM</p>
            <p className="text-2xl font-semibold text-white" data-testid="puntos-disponibles">{info.disponibles.toLocaleString('es-CO')} <span className="text-sm font-normal text-zinc-400">= {cop(info.valor_disponible)} COP</span></p>
          </div>
        </div>
        <p className="mt-3 text-xs text-zinc-400">Cada punto equivale a {cop(info.valor_por_punto)} COP de descuento.</p>
      </div>

      {max > 0 ? (
        <div className="space-y-4 rounded-2xl border border-[#27272A] bg-[#18181B] p-5">
          <p className="text-sm text-zinc-300">¿Cuántos puntos quieres usar? <span className="text-zinc-500">(máximo {max.toLocaleString('es-CO')})</span></p>
          <input type="range" min={0} max={max} value={puntos} onChange={e => fijar(Number(e.target.value))} className="w-full accent-[#C9A962]" data-testid="puntos-rango" />
          <div className="flex flex-wrap items-center gap-2">
            <input type="number" inputMode="numeric" min={0} max={max} value={puntos} onChange={e => fijar(Number(e.target.value))}
              className="w-32 rounded-xl border border-[#27272A] bg-[#0A0A0A] px-3 py-2.5 text-white outline-none focus:border-[#C9A962]" data-testid="puntos-input" />
            <button type="button" onClick={() => fijar(0)} className="rounded-xl border border-[#27272A] px-3 py-2.5 text-sm text-zinc-300 hover:border-zinc-500" data-testid="puntos-ninguno">No usar</button>
            <button type="button" onClick={() => fijar(max)} className="rounded-xl border border-[#C9A962]/40 px-3 py-2.5 text-sm text-[#C9A962] hover:bg-[#C9A962]/10" data-testid="puntos-maximo">Usar el máximo</button>
          </div>
          <div className="space-y-2">
            <Fila label="Precio" valor={`${cop(precio)} COP`} />
            <Fila label={`Descuento con ${puntos.toLocaleString('es-CO')} puntos`} valor={`-${cop(descuento)} COP`} testId="puntos-descuento" />
            <Fila label="Total a pagar" valor={`${cop(precio - descuento)} COP`} fuerte testId="puntos-total" />
          </div>
        </div>
      ) : (
        <p className="rounded-2xl border border-[#27272A] bg-[#18181B] p-5 text-sm text-zinc-400" data-testid="puntos-sin-saldo">
          {info.programa_activo ? 'Aún no tienes puntos para usar en esta compra. Puedes continuar sin descuento.' : 'La redención de Puntos JPM no está disponible en este momento. Puedes continuar sin descuento.'}
        </p>
      )}
    </div>
  );
}
